import * as React from 'react';
import {
  getFormsReport,
  FormsReportType,
} from '../../api/reports';
import { LoaderWithContainer } from '../../molecules';
import ModalInfo from '../../molecules/ModalInfo';
import FormsReportList from '../../organisms/FormsReportList';
import { clearRequestError, requestApiErrorObj, setRequestError } from '../../redux/ducks/requestApiError';
import { dispatch } from '../../redux/store';

const FormsReport = React.forwardRef(
  (
    {
      formsDate,
      inspector,
      setSelectedFormsReports,
      selectedFormsReports,
      setIsValidForExport,
      forms,
      setForms,
    }: Props,
    ref,
  ) => {
    const [isLoading, setIsLoading] = React.useState(false);

    const [errMsg, setErrMsg] = React.useState(false);

    const [skipped, setSkipped] = React.useState<Array<SkippedInspection>>([]);

    React.useEffect(() => {
      if (formsDate && inspector) {
        setIsLoading(true);
        getFormsReport({
          date: formsDate,
          inspector,
        })
          .then(res => {
            // The endpoint used to return a bare array and now returns
            // { forms, skipped }. Accept both so the API and the UI can deploy
            // in either order.
            const { data } = res;
            const nextForms = Array.isArray(data) ? data : data?.forms || [];
            const nextSkipped = Array.isArray(data) ? [] : data?.skipped || [];

            setSkipped(nextSkipped);
            setIsValidForExport(nextForms.length > 0);
            setForms(nextForms);
            setSelectedFormsReports(nextForms.map(el => el?.id));
          })
          .catch(err => {
            if (err && err.response && err.response.status === 500) {
              dispatch(clearRequestError());
              setErrMsg(true);
            }
          })
          .finally(() => setIsLoading(false));
      }
    }, [formsDate, inspector]);
    if (isLoading) {
      return <LoaderWithContainer />;
    }
    if (errMsg) {
      return (
        <div style={{ height: '100vh' }}>
          <ModalInfo isError errorMsg="Inspection Form is not configured for this jurisdiction. Please have your administrator configure this in admin settings." />
        </div>
      );
    }

    return (
      <FormsReportList
        ref={ref}
        forms={forms}
        skipped={skipped}
        setSelectedFormsReports={setSelectedFormsReports}
        selectedFormsReports={selectedFormsReports}
      />
    );
  },
);

export interface SkippedInspection {
  inspection: number;
  jurisdiction: string | null;
  reason: 'no_form' | 'render_failed';
}

interface Props {
  formsDate: string;
  inspector: number;
  setSelectedFormsReports: (data: any) => void;
  selectedFormsReports: Array<FormsReportType>;
  setIsValidForExport: () => void;
}

export default FormsReport;
